export default "__VITE_ASSET__BNSx0f4d__"